// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qFit","name":"styles_name__3c-iI","phone":"styles_phone__ajK-u"};